export default __webpack_public_path__ + "static/media/photo--sm--21.fe170c16.jpg";